import * as ABCya from '@abcya/abcya_phaser';

import gameData from "../../gameData";
import sKey from '../../SoundAssetKeys';

export async function createChooseShape(scene) 
{
    if(!gameData.makeData.shapeUI)
    {
        createUI(scene);
        return shapeTween();
        
    }
    else
    {
        scene.makeDonut.setAlpha(0);
        scene.makeDonut.setFrame('Donuts and Sprinkles/Donut_Ring_Plain');
        shapeTween();
    }

}

export function cleanUpShape(scene)
{
    for(let each in gameData.makeData.shapeUI)
    {
        gameData.makeData.shapeUI[each].setAlpha(0);
    }  
    scene.selector2.setAlpha(0);
}

function createUI(scene)
{
    const donutShapeBut = [];
    let selected = "Ring";

    donutShapeBut.push(ABCya.Images.addImage(512, 228, "Donuts and Sprinkles/Donut_Ring_Plain",scene).setScale(.66));
    donutShapeBut.push(ABCya.Images.addImage(699, 324, "Donuts and Sprinkles/Donut_Heart_Plain",scene).setScale(.66));
    donutShapeBut.push(ABCya.Images.addImage(700, 520, "Donuts and Sprinkles/Donut_Round_Plain",scene).setScale(.66));
    donutShapeBut.push(ABCya.Images.addImage(512, 615, "Donuts and Sprinkles/Donut_Triangle_Plain",scene).setScale(.75));
    donutShapeBut.push(ABCya.Images.addImage(328, 520, "Donuts and Sprinkles/Donut_Square_Plain",scene).setScale(.66));
    donutShapeBut.push(ABCya.Images.addImage(327, 322, "Donuts and Sprinkles/Donut_Star_Plain",scene).setScale(.66));

    gameData.makeData.shapeUI = donutShapeBut;

    scene.selector2.setFrame("General UI/Selected_Round");
    scene.selector2.setScale(donutShapeBut[1].scale);
    scene.selector2.setPosition(donutShapeBut[1].x, donutShapeBut[1].y);
    scene.selector2.setDepth(4);

    for(let each in donutShapeBut)
    {
        donutShapeBut[each].setInteractive();

        donutShapeBut[each].onScreen = {x:donutShapeBut[each].x,y:donutShapeBut[each].y};

        tweenPoints(donutShapeBut[each]);

        const frameName = donutShapeBut[each].frame.name;
        const nameSplit = frameName.split("_");
        
        if(nameSplit[1] === "Ring") donutShapeBut[each].selectorType = `General UI/Selected_Round`;
        else donutShapeBut[each].selectorType = `General UI/Selected_${nameSplit[1]}`;
        
        donutShapeBut[each].on("pointerdown",()=>{
            scene.custSound.playSoundCustom(sKey._click_select_donuts);
            const donut = donutShapeBut[each];
            gameData.makeData.selected.shape = nameSplit[1];
            scene.selector2.setFrame(donut.selectorType);
            scene.selector2.setScale(donut.scale);
            scene.selector2.setPosition(donut.x, donut.y);
            scene.selector2.setAlpha(1);
        });
    }
}

function shapeTween()
{
    return new Promise(resolve=>{
        const scene = gameData.makeData.shapeUI[0].scene;
        scene.custSound.playSoundCustom(sKey._title_donut_enter)
        for(let each in gameData.makeData.shapeUI)
        {
            const shape = gameData.makeData.shapeUI[each];
            shape.disableInteractive();
            ABCya.Tweens.addTween(shape,500,{x:{start:shape.offScreen.x, to:shape.onScreen.x}, y:{start:shape.offScreen.y, to: shape.onScreen.y}, alpha:{start:1,to:1}}, Phaser.Math.Easing.Quadratic.InOut,()=>{
                shape.setInteractive();
                if(Number(each) === gameData.makeData.shapeUI.length - 1)
                {
                    resolve();
                }
            });
            
        }
    });
}

function tweenPoints(shape)
{
    const name = shape.frame.name.split("_")[1];
    const offSet = 428;
    switch(name)
    {
        case "Ring":
            shape.offScreen = {x:shape.onScreen.x, y:shape.onScreen.y-offSet};
            break;
        case "Heart":
            shape.offScreen = {x:shape.onScreen.x+offSet, y:shape.onScreen.y-offSet};
            break;
        case "Round":
            shape.offScreen = {x:shape.onScreen.x+offSet, y:shape.onScreen.y+offSet};
            break;
        case "Triangle":
            shape.offScreen = {x:shape.onScreen.x, y:shape.onScreen.y+offSet};
            break;
        case "Square":
            shape.offScreen = {x:shape.onScreen.x-offSet, y:shape.onScreen.y+offSet};
            break;
        case "Star":
            shape.offScreen = {x:shape.onScreen.x-offSet, y:shape.onScreen.y-offSet};
            break;
    }
}

export function shapeTweenOut(scene)
{
    return new Promise(resolve=>{

        let shape;
        let tempArr = [...gameData.makeData.shapeUI];
        scene.selector2.setAlpha(0);

        switch(gameData.makeData.selected.shape)
        {
            case "Ring":
                shape = gameData.makeData.shapeUI[0];
                tempArr.splice(0,1);
                break;
            case "Heart":
                shape = gameData.makeData.shapeUI[1];
                tempArr.splice(1,1);
                break;
            case "Round":
                shape = gameData.makeData.shapeUI[2];
                tempArr.splice(2,1);
                break;
            case "Triangle":
                shape = gameData.makeData.shapeUI[3];
                tempArr.splice(3,1);
                break;
            case "Square":
                shape = gameData.makeData.shapeUI[4];
                tempArr.splice(4,1);
                break;
            case "Star":
                shape = gameData.makeData.shapeUI[5];
                tempArr.splice(5,1);
                break;
        }

        let time = 500;
        scene.custSound.playSoundCustom(sKey._title_donut_leave);
        for(let each in tempArr)
        {
            tempArr[each].disableInteractive();
            ABCya.Tweens.addTween(tempArr[each],time,{x:tempArr[each].offScreen.x,y:tempArr[each].offScreen.y,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>{
                ABCya.Tweens.addTween(tempArr[each],100,{alpha:0},Phaser.Math.Easing.Quadratic.InOut);
            });
        }

        shape.setInteractive();
        scene.makeDonut.setFrame(shape.frame.name);

        let tween = ABCya.Tweens.addTween(shape,time,{x:512,y:405,scale:1,yoyo:true},Phaser.Math.Easing.Quadratic.InOut);
        tween.on('yoyo',()=>{
            shape.setAlpha(0);
            scene.makeDonut.setAlpha(1);
            scene.makeDonut.setDepth(5);
            resolve();
        })
    });
}
    